import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ul/toaster';
import { SettingsProvider } from './context/SettingsContext';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import FloatingContact from './components/FloatingContact';

function App() {
    return (
        <SettingsProvider>
            <BrowserRouter>
                <main id="main-content">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/hizmetler" element={<ServicesPage />} />
                        <Route path="/hizmet/:slug" element={<ServiceDetailPage />} />
                        <Route path="/hakkimizda" element={<AboutPage />} />
                        <Route path="/iletisim" element={<ContactPage />} />
                        <Route path="/galeri" element={<GalleryPage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/blog/:slug" element={<BlogPostPage />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </main>
                <FloatingContact />
                <Toaster />
            </BrowserRouter>
        </SettingsProvider>
    );
}

export default App;
